import React, { Component } from 'react';
import { Tile, BodyText, Link, CaptionText } from '@paypalcorp/pp-react';
import uniq from 'lodash/uniq';
import styles from './hubCharityCard.less';
import OverflowMenu from '../OverflowMenu/OverflowMenu';
import trimText from '../../lib/trimText';

export default class HubCharityCard extends Component {
  charityCategories(categories) {
    // display categories in one line, append with ... when the total category string length is beyond 28

    let displayLength = this.props.isMobile ? 44 : 28;
    let categoryString = '';
    for (let i = 0; i < categories.length; i++) {
      categoryString = categoryString + categories[i];
      if (categoryString.length > displayLength) {
        categoryString = trimText(displayLength, categoryString);
        return (
          <CaptionText size='md' className={styles.categoryDisplay}>
            {categoryString}
          </CaptionText>
        );
      } else {
        if (i === categories.length - 1) {
          return (
            <CaptionText size='md' className={styles.categoryDisplay}>
              {categoryString}
            </CaptionText>
          );
        }
        categoryString = categoryString + ', ';
      }
    }
  }

  handleKeyPressOnCharity(e) {
    if (e.key === 'Enter') {
      this.props.viewCharity();
    }
  }

  render() {
    const causeAreas = this.props.causeArea;
    let categories = [];
    if (Array.isArray(causeAreas)) {
      categories =
        uniq(
          causeAreas.map((causeArea) =>
            this.props.i18n(`label.category-${causeArea.id}`)
          )
        ) || [];
    }

    return (
      <div
        onClick={() => this.props.viewCharity()}
        id={this.props.locatorId || `nemo_charity_card_${this.props.testId}`}
        onKeyDown={this.handleKeyPressOnCharity.bind(this)}
        tabIndex='0'
        role='link'
      >
        <Tile className={styles.charityCard} card>
          <OverflowMenu hubFlow={true} fptiInfo={this.props.fptiInfo}>
            <li
              onClick={(e) => {
                e.stopPropagation();
                this.props.handleLearnMoreClick();
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            >
              <Link
                href={
                  this.props.npoUrl || `/fundraiser/charity/${this.props.npid}`
                }
                target='_blank'
                className='vx_overflowMenu-item'
                aria-describedby='vx_overflowMenu-itemDescriptor'
              >
                {this.props.i18n(
                  this.props.menuOption || 'label.overFlowMenuList1'
                )}
              </Link>
            </li>
          </OverflowMenu>
          <Tile.Content className={styles.charityCardContent}>
            <div
              className={styles.cardImage}
              style={{
                background: `url(${this.props.logo_url}) no-repeat center, center`,
                backgroundSize: 'contain',
              }}
            />
            <div className={styles.charityTextClamp}>
              <BodyText size='lg' className={styles.charityNameClamp}>
                {this.props.name}
              </BodyText>
              {this.charityCategories(categories)}
            </div>
          </Tile.Content>
        </Tile>
      </div>
    );
  }
}
